export default [{
    path: '/pool/consumptionPool',
    name: 'consumptionPool',
    meta: {
      index: 15
    },
    component: () => import('@/views/pool/consumptionPool.vue')
  }]
  